(function(){
  'use strict';

  // Copy code buttons — swap label text via .copy-label if present, else rely on CSS .done state
  document.querySelectorAll('[data-copy]').forEach(btn => {
    btn.addEventListener('click', async () => {
      try { await navigator.clipboard.writeText(btn.dataset.copy); } catch(e){}
      const label = btn.querySelector('.copy-label');
      btn.classList.add('done');
      let old = null;
      if (label){
        old = label.textContent;
        label.textContent = 'Kopiert';
      }
      setTimeout(() => {
        btn.classList.remove('done');
        if (label && old !== null) label.textContent = old;
      }, 1600);
    });
  });

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.remove('gsap-hero-init');
  if (reduceMotion || !window.gsap) return;

  gsap.registerPlugin(ScrollTrigger);

  // Helper: animate list when scrolled into view. Uses set→to pattern which
  // is the most robust GSAP/ScrollTrigger approach and never leaves items
  // permanently hidden if the trigger behaves oddly.
  function reveal(selector, options = {}) {
    const els = gsap.utils.toArray(selector);
    if (!els.length) return;

    const {
      y = 24,
      opacity = 0,
      scale = 1,
      x = 0,
      rotation = 0,
      duration = 0.8,
      stagger = 0.08,
      ease = 'power3.out',
      delay = 0,
      trigger = els[0],
      start = 'top 85%',
    } = options;

    // Set start state
    gsap.set(els, { y, opacity, scale, x, rotation });

    // Animate to natural state when the trigger enters the viewport
    ScrollTrigger.create({
      trigger,
      start,
      once: true,
      onEnter: () => {
        gsap.to(els, {
          y: 0, opacity: 1, scale: 1, x: 0, rotation: 0,
          duration, stagger, ease, delay,
        });
      },
    });
  }

  // ---------- HERO ENTRY (runs on load, no scroll trigger) ----------

  // Hero H1 lines: gentle fade + rise, NO overflow mask (avoids descender clipping)
  const heroLines = document.querySelectorAll('.t3f2 .hero h1 .line');
  if (heroLines.length) {
    gsap.set(heroLines, { opacity: 0, y: 28 });
    gsap.to(heroLines, {
      opacity: 1,
      y: 0,
      duration: 0.9,
      stagger: 0.1,
      ease: 'power3.out',
      delay: 0.15,
    });
  }

  // Hero copy fades up
  const heroFade = gsap.utils.toArray('.t3f2 .hero .eyebrow-line, .t3f2 .hero .lede, .t3f2 .hero .value-strip, .t3f2 .hero .cta-row, .t3f2 .hero .cta-subline, .t3f2 .hero .trust');
  if (heroFade.length) {
    gsap.set(heroFade, { y: 18, opacity: 0 });
    gsap.to(heroFade, {
      y: 0, opacity: 1,
      duration: 0.7,
      stagger: 0.08,
      ease: 'power3.out',
      delay: 0.35,
    });
  }

  // Hero media scales in
  if (document.querySelector('.t3f2 .hero .media')) {
    gsap.set('.t3f2 .hero .media', { scale: 0.97, opacity: 0 });
    gsap.to('.t3f2 .hero .media', {
      scale: 1, opacity: 1,
      duration: 1.1,
      ease: 'power3.out',
      delay: 0.2,
    });
  }

  // Hero image soft parallax on scroll
  const heroImg = document.querySelector('.t3f2 .hero .media img');
  if (heroImg) {
    gsap.to(heroImg, {
      yPercent: 6,
      ease: 'none',
      scrollTrigger: {
        trigger: '.t3f2 .hero',
        start: 'top top',
        end: 'bottom top',
        scrub: 0.6,
      },
    });
  }

  // ---------- SCROLL-TRIGGERED REVEALS ----------

  reveal('.t3f2 .bento .tile', { y: 40, stagger: 0.12, duration: 0.9 });
  reveal('.t3f2 .tile--step-1 .trio .thumb', { scale: 0.7, y: 0, stagger: 0.12, duration: 0.6, ease: 'back.out(1.7)', trigger: '.t3f2 .tile--step-1', start: 'top 75%' });
  reveal('.t3f2 .tile--step-2 .cart-mock .code-val', { x: -10, y: 0, duration: 0.6, trigger: '.t3f2 .tile--step-2', start: 'top 75%' });
  reveal('.t3f2 .tile--step-2 .cart-mock .check-ico', { scale: 0, rotation: -90, y: 0, duration: 0.7, ease: 'back.out(2)', delay: 0.3, trigger: '.t3f2 .tile--step-2', start: 'top 75%' });
  reveal('.t3f2 .tile--step-3 .receipt > *', { y: 10, stagger: 0.09, duration: 0.5, trigger: '.t3f2 .tile--step-3', start: 'top 75%' });

  reveal('.t3f2 .usp .cell', { y: 16, stagger: 0.06, duration: 0.7, trigger: '.t3f2 .usp' });
  reveal('.t3f2 .cat-grid .prod', { y: 28, stagger: 0.05, duration: 0.7, trigger: '.t3f2 .cat-grid' });

  // Material: image stays fixed (no parallax — would peek the peach bg through position: absolute inset 0)
  reveal('.t3f2 .mat-copy > *', { y: 20, stagger: 0.08, duration: 0.7, trigger: '.t3f2 .material', start: 'top 78%' });
  reveal('.t3f2 .fact-list .fact', { y: 14, stagger: 0.07, duration: 0.6, trigger: '.t3f2 .fact-list' });
  reveal('.t3f2 .quote', { y: 24, stagger: 0.1, duration: 0.7 });
  reveal('.t3f2 .qa', { y: 14, stagger: 0.06, duration: 0.6, trigger: '.t3f2 .faq-list' });
  reveal('.t3f2 .cta-card', { scale: 0.97, y: 0, duration: 1 });
  reveal('.t3f2 .cta-card .eyebrow, .t3f2 .cta-card h2, .t3f2 .cta-card p, .t3f2 .cta-card .btns', { y: 18, stagger: 0.08, duration: 0.7, delay: 0.2, trigger: '.t3f2 .cta-card', start: 'top 80%' });
  reveal('.t3f2 .nl-grid > *', { y: 16, stagger: 0.1, duration: 0.7, trigger: '.t3f2 .nl', start: 'top 88%' });

  // ---------- Hover micro-interactions ----------

  // Primary CTA lift
  document.querySelectorAll('.t3f2 .btn--ink, .t3f2 .btn--light').forEach(btn => {
    btn.addEventListener('mouseenter', () => gsap.to(btn, { y: -2, duration: 0.25, ease: 'power2.out' }));
    btn.addEventListener('mouseleave', () => gsap.to(btn, { y: 0, duration: 0.25, ease: 'power2.out' }));
  });

  // Refresh ScrollTrigger after full load (fonts/images shift positions)
  window.addEventListener('load', () => ScrollTrigger.refresh());

  // ---------- Footer accordion on mobile ----------
  const footerSections = document.querySelectorAll('.t3f2 footer .fgrid > div:not(:first-child)');
  const footerAccordionMq = window.matchMedia('(max-width: 640px)');
  footerSections.forEach(section => {
    const h5 = section.querySelector('h5');
    if (!h5) return;
    h5.addEventListener('click', () => {
      if (!footerAccordionMq.matches) return;
      section.classList.toggle('is-open');
    });
  });

  // ---------- MOBILE STICKY CTA: show after hero, hide at final-CTA ----------
  const mbar = document.getElementById('mbar');
  const hero = document.querySelector('.t3f2 .hero');
  const finalBlock = document.querySelector('.t3f2 .ctablock');
  if (mbar && hero){
    ScrollTrigger.create({
      trigger: hero,
      start: 'bottom top',
      end: finalBlock ? 'top top' : 'bottom+=99999 top',
      endTrigger: finalBlock || undefined,
      onToggle: (self) => {
        mbar.classList.toggle('is-visible', self.isActive);
      },
    });
  }

})();